export class JobSkillType{
  public skillTypeId: number = 0;
  public skillTypeName: string = '';
  public selected : boolean = false;
}